<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="添加 MyToken"
      width="500px"
      @close="closeDialog"
    >
      <el-form
        :model="myTokenDetail"
        ref="myTokenForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="币种:" prop="symbol">
          <el-select v-model="myTokenDetail.symbol" placeholder="请选择">
            <el-option
              v-for="item in coinList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'myTokenDetail',
  data() {
    return {
      myTokenDetail: {},
      dialogVisible: false,
      rules: {
        symbol: [
          {
            required: true,
            message: '请选择币种！'
          }
        ]
      }
    };
  },
  computed: {
    ...mapState('myTokenCurrency', ['coinList'])
  },
  methods: {
    ...mapActions('myTokenCurrency', ['getCoinList', 'create']),
    closeDialog() {
      this.dialogVisible = false;
      this.myTokenDetail = {};
      this.$refs['myTokenForm'].resetFields();
    },
    handleSave() {
      this.$refs['myTokenForm'].validate(valid => {
        if (valid) {
          const symbol = this.myTokenDetail.symbol;
          this.create({
            symbol,
            name: symbol
          }).then(() => {
            this.$message.success('添加成功');
            this.dialogVisible = false;
            this.$emit('refresh');
          });
        }
      });
    }
  },
  created() {
    this.getCoinList();
  }
};
</script>
